module.exports = __webpack_public_path__ + "b874d35c836748f03566934daab20397.jpg";